import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";
import AlertBell from "./AlertBell";
import TrialBanner from "./TrialBanner";

export default function AppShell() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-ivory">
                <div className="label-eyebrow">Loading EuroLaw Hub…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
    }
    // Force password reset before granting access to any /app/* route
    if (user.must_reset_password && location.pathname !== "/password-reset") {
        return <Navigate to="/password-reset" replace />;
    }

    return (
        <div className="min-h-screen flex bg-[#F5F0E8]" data-testid="app-shell">
            <Sidebar />
            <main className="flex-1 min-w-0 pb-24 lg:pb-0 relative">
                <TrialBanner />
                <div className="absolute top-5 right-5 lg:top-7 lg:right-9 z-30">
                    <AlertBell />
                </div>
                <Outlet />
            </main>
            <BottomNav />
        </div>
    );
}
